export default __webpack_public_path__ + "static/media/BGSplash.a62198fc.webp";